import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-focus-2-line"></i>
            编辑精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            精选主题推荐，发现更多好看的韩漫
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 aspect-video sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  width="400"
                  height="225"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium mt-3 group-hover:gap-2 transition-all">
                  查看专题
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}